import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/customer-applications/:applicationId?",
    name: "Applications",
    component: () => import("./applications.vue"),
  },
  {
    path: "/customer-correspondence",
    name: "CustomerCorrespondence",
    component: () => import("./customerCorrespondence.vue"),
  },
  {
    path: "/customer-detail/:remoteSystemId/:remoteAcctNumber(\\d+)",
    name: "Customer Details",
    component: () => import("./customerSearch/choiceCustomerDetail.vue"),
    props: true,
  },
  {
    path: "/web-logins",
    name: "Web Login Manager",
    component: () => import("./webLoginManager.vue"),
    props: true,
  },
  {
    path: "/customer-search/:searchType?/:searchValue?",
    name: "Customer Search",
    component: () => import("./customerSearch.vue"),
    props: true,
  },
  {
    path: "/print-documents",
    name: "Choice Invoices",
    component: () => import("./choiceInvoices.vue"),
  },
  {
    path: "/shipley-rewards-admin",
    name: "Shipley Rewards Admin",
    component: () => import("./shipleyRewardsAdmin.vue"),
  },
  {
    path: "/tank-monitor-config",
    name: "Tank Monitors",
    component: () => import("./tankMonitorConfig.vue"),
  },
] satisfies RouteRecordRaw[];
